import intro01 from "./Introduccion/Intro-01.mp3";
import intro02 from "./Introduccion/Intro-02.mp3";

import sub1a01 from "./Subtema-1/T8-Sub 1-Act 1-A01.mp3";
import sub1a02 from "./Subtema-1/T8-Sub 1-Act 1-A02.mp3";
import sub1a03 from "./Subtema-1/T8-Sub 1-Act 1-A03.mp3";
import sub1a04 from "./Subtema-1/T8-Sub 1-Act 1-A04.mp3";
import sub1a05 from "./Subtema-1/T8-Sub 1-Act 1-A05.mp3";
import sub1a06 from "./Subtema-1/T8-Sub 1-Act 1-A06.mp3";
import sub1a07 from "./Subtema-1/T8-Sub 1-Act 1-A07.mp3";
import sub1a08 from "./Subtema-1/T8-Sub 1-Act 1-A08.mp3";
import sub1a09 from "./Subtema-1/T8-Sub 1-Act 1-A09.mp3";
import sub1a10 from "./Subtema-1/T8-Sub 1-Act 1-A10.mp3";

import sub2a1a01 from "./Subtema-2/Actividad-1/T8-Sub 2-Act 1-A01.mp3";
import sub2a1a02 from "./Subtema-2/Actividad-1/T8-Sub 2-Act 1-A02.mp3";
import sub2a1a03 from "./Subtema-2/Actividad-1/T8-Sub 2-Act 1-A03.mp3";
import sub2a1a04 from "./Subtema-2/Actividad-1/T8-Sub 2-Act 1-A04.mp3";
import sub2a1a05 from "./Subtema-2/Actividad-1/T8-Sub 2-Act 1-A05.mp3";
import sub2a1a06 from "./Subtema-2/Actividad-1/T8-Sub 2-Act 1-A06.mp3";

import sub2a2a01 from "./Subtema-2/Actividad-2/T8-Sub 2-Act 2-A01.mp3";
import sub2a2a02 from "./Subtema-2/Actividad-2/T8-Sub 2-Act 2-A02.mp3";
import sub2a2a03 from "./Subtema-2/Actividad-2/T8-Sub 2-Act 2-A03.mp3";

import sub2a3a01 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A01.mp3";
import sub2a3a02 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A02.mp3";
import sub2a3a03 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A03.mp3";
import sub2a3a04 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A04.mp3";
import sub2a3a05 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A05.mp3";
import sub2a3a06 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A06.mp3";
import sub2a3a07 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A07.mp3";
import sub2a3a08 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A08.mp3";
import sub2a3a09 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A09.mp3";
import sub2a3a10 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A10.mp3";
import sub2a3a11 from "./Subtema-2/Actividad-3/T8-Sub 2-Act 3-A11.mp3";

import sub2a4a01 from "./Subtema-2/Actividad-4/T8-Sub 2-Act 4-A01.mp3";

import sub2a5a01 from "./Subtema-2/Actividad-5/T8-Sub 2-Act 5-A01.mp3";


export const T8_voices = {
	introduccion: {
		intro01,
		intro02,
	},
	subtema1: {
		actividad1: {
			sub1a01,
			sub1a02,
			sub1a03,
			sub1a04,
			sub1a05,
			sub1a06,
			sub1a07,
			sub1a08,
			sub1a09,
			sub1a10,
		},
	},
	subtema2: {
		actividad1: {
			sub2a1a01,
			sub2a1a02,
			sub2a1a03,
			sub2a1a04,
			sub2a1a05,
			sub2a1a06,
		},
		actividad2: {
			sub2a2a01,
			sub2a2a02,
			sub2a2a03,
		},
		actividad3: {
			sub2a3a01,
			sub2a3a02,
			sub2a3a03,
			sub2a3a04,
			sub2a3a05,
			sub2a3a06,
			sub2a3a07,
			sub2a3a08,
			sub2a3a09,
			sub2a3a10,
			sub2a3a11,
		},
		actividad4: {
			sub2a4a01,
		},
		actividad5: {
			sub2a5a01,
		},
	},
};
